import CloseIcon from "@mui/icons-material/CloseRounded";
import { IconButton, Snackbar, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { sessionStorageService } from "../services/storage";
import { getSafariMajorVersion } from "../utilities/userAgentHelper";

const isBrowserChecked = () => sessionStorageService.getItemWithFallback("browser_check", false);

const saveBrowserChecked = () => sessionStorageService.setItem("browser_check", true);

const isBrowserOutdated = () => {
  if (isBrowserChecked()) {
    return false;
  }

  saveBrowserChecked();

  // Safari < 17 can't parse ES6+ workers (pdfjs requirement)
  const safariVersion = getSafariMajorVersion();
  if (safariVersion !== undefined && safariVersion < 17) {
    return true;
  }

  // Check for some of the ES2022 features.
  return typeof Array.prototype.at !== "function" || typeof window.structuredClone !== "function";
};

const OutdatedBrowserAlert = () => {
  const [isOpen, setIsOpen] = useState(isBrowserOutdated);

  return (
    <Snackbar
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      open={isOpen}
      onClose={() => setIsOpen(false)}
      message={
        <Stack>
          <Typography variant="subtitle1">Your browser is outdated.</Typography>
          <Typography>Please update it to the latest version, otherwise the app may not work correctly.</Typography>
        </Stack>
      }
      sx={(t) => ({
        ".MuiPaper-root": {
          color: t.palette.warning.contrastText,
          backgroundColor: t.palette.warning.main,
        },
      })}
      action={
        <IconButton color="inherit" onClick={() => setIsOpen(false)}>
          <CloseIcon />
        </IconButton>
      }
    />
  );
};

export default OutdatedBrowserAlert;
